import React, { useEffect, useState } from "react";
import Header from "../../../components/header/Header";
import { ReactComponent as Icon1 } from "../../../assets/icons/policyAbout/PolicEeye.svg";
import { ReactComponent as Icon2 } from "../../../assets/icons/policyAbout/PoliceLock.svg";
import { ReactComponent as Icon3 } from "../../../assets/icons/policyAbout/PoliceLightbulb.svg";
import { ReactComponent as Icon4 } from "../../../assets/icons/policyAbout/PoliceCapSolid.svg";
import icon1 from "../../../assets/kycBlocks/icon1.png";
import icon2 from "../../../assets/kycBlocks/icon2.png";
import icon3 from "../../../assets/kycBlocks/icon3.png";
import "./PolicyAbout.css";
import { useTranslation } from "react-i18next";
import AboutGallaryInfo from "./AboutGallaryInfo/BlockAboutGallaryInfo/AboutGallaryInfo";
import TextBlockAbout from "./AboutGallaryInfo/TextBlockAbout/TextBlockAbout";
import { useLocation, useParams } from "react-router-dom";

const PolicyAbout = () => {
  const { t } = useTranslation();
  const params = useParams();

  console.log(window.location.pathname.includes("policy-about"));

  const { hash } = useLocation();

  // Состояние для показа/скрытия нижних двух абзацев
  const [showExtra, setShowExtra] = useState(false);

  useEffect(() => {
    if (hash === "#contacts") {
      const el = document.getElementById("contacts");
      if (el) {
        setTimeout(() => {
          el.scrollIntoView({ behavior: "smooth" });
        }, 100);
      }
    }
  }, [hash]);

  return (
    <div className="PolicyAbout">
      <Header hasMenu2={true} />
      <div className="contentPolicyAbout">
        <div className="blockTexst">
          <h3>{t("policyAbout.h3")}</h3>
          <h2>{t("policyAbout.h2")}</h2>
          <div className="blockP">
            <p>{t("policyAbout.description1")}</p>
            {showExtra && (
              <>
                <p>{t("policyAbout.description2")}</p>
                <p>{t("policyAbout.description3")}</p>
              </>
            )}
          </div>
          <button onClick={() => setShowExtra(!showExtra)}>
            {showExtra ? "скрыть" : "открыть"}
          </button>
        </div>

        <div className="blockIcon">
          <div className="containerIcon">
            <img src={icon1} alt="icon1" />
            <h4>{t("policyAbout.h4-1")}</h4>
            <p>{t("policyAbout.description4")}</p>
          </div>

          <div className="containerIcon">
            <img src={icon2} alt="icon2" />
            <h4>{t("policyAbout.h4-2")}</h4>
            <p>{t("policyAbout.description5")}</p>
          </div>

          <div className="containerIcon">
            <img src={icon3} alt="icon3" />
            <h4>{t("policyAbout.h4-3")}</h4>
            <p>{t("policyAbout.description6")}</p>
          </div>
        </div>
      </div>

      <footer id="contacts">
        <h3>{t("policyAbout.contactsText")}</h3>
        <p>
          {t("policyAbout.mail")}{" "}
          <a href="mailto:support@fynex.net">support@fynex.net</a>
        </p>
        <p>Telegram: <a href="https://t.me/fynex_support_bot" target="_blank">@fynex_support_bot</a></p>
        {/* <p>{t("policyAbout.INN")} 983822345</p> */}
      </footer>
    </div>
  );
};

export default PolicyAbout;
